import { RouteConfig } from "vue-router";

import Layout from "@/layout/index.vue";

const shoppingRouter: RouteConfig = {
  path: "/pro",
  name: "pro",
  component: Layout,
  meta: {
    title: "商店管理",
    icon: "setting",
    permission: "Pages.Settings"
  },
  children: [
    {
      path: "/Carousel",
      name: "/Carousel",
      component: () => import('@/views/shopping/Carousel/index.vue'),
      meta: {
        title: "广告位管理",
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "/Coupon",
      name: "/Coupon",
      component: () => import('@/views/shopping/Coupon/index.vue'),
      meta: {
        title: "促销管理",
        permission: "Pages.Settings.User"
      }
    },
    {
      path: "/Coupon/create",
      name: "CreateCoupon",
      component: () =>
        import("@/views/shopping/Coupon/create-coupon.vue"),
      meta: {
        title: "添加促销",
        hidden: true
      }
    },
     {
      path: "/Coupon/update/:id",
      name: "CreateCoupon",
      component: () =>
        import("@/views/shopping/Coupon/update-coupon.vue"),
      meta: {
        title: "修改促销",
        hidden: true
      }
    },
    {
      path: "/carousel/create",
      name: "Createproductcategory",
      component: () =>
        import("@/views/shopping/Carousel/create-carousel.vue"),
      meta: {
        title: "添加广告",
        hidden: true

      }
    },
     {
      path: "/carousel/update/:id",
      name: "Createcarousel",
      component: () =>
        import("@/views/shopping/Carousel/update-carousel.vue"),
      meta: {
        title: "修改广告",
        hidden: true

      }
    },
    {
      path: "/product",
      name: "/Product",
      component: () => import('@/views/index.vue'),
      meta: {
        title: "商品中心",
        permission: "Pages.Settings.User"
      },
      children: [
        {
          path: "product/list",
          name: "ProductList",
          component: () =>
            import(
            /* webpackChunkName: "pay-settings" */ "@/views/shopping/product/index.vue"
            ),
          meta: {
            title: "商品管理",
            permission: "Pages.Settings.User"
          }
        },
        {
          path: "productcategory/list",
          name: "productcategory",
          component: () =>
            import("@/views/shopping/productcategory/index.vue"),
          meta: {
            title: "商品分类",
            permission: "Pages.Settings.User"
          }
        },
        {
          path: "/product/productcategory/create",
          name: "Createproductcategory",
          component: () =>
            import("@/views/shopping/productcategory/create-productcategory.vue"),
          meta: {
            title: "添加产品分类",
            hidden: true

          }
        }, {
          path: "/product/productcategory/update/:id",
          name: "Updateproductcategory",
          component: () =>
            import("@/views/shopping/productcategory/update-productcategory.vue"),
          meta: {
            title: "修改产品产品",
            hidden: true
          }
        },
        {
          path: "/product/product/create",
          name: "Createproduct",
          component: () =>
            import("@/views/shopping/product/create-product.vue"),
          meta: {
            title: "添加商品",
            hidden: true

          }
        }, {
          path: "/product/product/update/:id",
          name: "Updateproduct",
          component: () =>
            import("@/views/shopping/product/update-product.vue"),
          meta: {
            title: "修改产品",
            hidden: true
          }
        }
      ]
    },
    {
      path: "/order",
      name: "/order",
      component: () => import('@/views/index.vue'),
      meta: {
        title: "订单管理",
        permission: "Pages.Settings.User"
      },
      children:
        [
          {
            path: "/promotionalOrder/promotionalOrderlist",
            name: "PromotionalOrderlist",
            meta: {
              title: "预约单管理",
              permission: "Pages.Settings.User"
            },
            component: () =>
              import("@/views/shopping/PromotionalOrder/index.vue"),
          },
          {
            path: "/order/orderlist",
            name: "orderlist",
            meta: {
              title: "订单管理",
              permission: "Pages.Settings.User"
            },
            component: () =>
              import("@/views/shopping/order/index.vue"),
          }, 
          {
            path: "product",
            name: "Product",
            meta: {
              title: "发货管理",
              permission: "Pages.Settings.User",
              hidden: true
            }
          }, 
          {
           
            path: "/order/orderDetails/look/:id",
            name: "orderDetails",
            component: () =>
              import(/* webpackChunkName: "user" */ "@/views/shopping/order/details.vue"),
            meta: {
              title: "订单详情",
              permission: "Pages.Settings.User",
              hidden: true
            }
          }
        ]
    }


  ]
};

export default shoppingRouter;
